document.addEventListener('DOMContentLoaded', () => {
  const widget = document.querySelector('#judgeme_product_reviews');
  if (!widget) return;

  let savedScrollY = null;

  // Remember page position before Judge.me pagination runs
  widget.addEventListener('click', (event) => {
    const paginationButton = event.target.closest(
      '.jm-pagination-controls__button'
    );

    if (!paginationButton) return;

    savedScrollY = window.scrollY;
  });

  const observer = new MutationObserver(() => {
    const list = widget.querySelector('.jdgm-review-list');

    requestAnimationFrame(() => {
      // Reset horizontal review cards to first card
      if (list) {
        list.scrollLeft = 0;
      }

      // Undo Judge.me's vertical jump
      if (savedScrollY !== null) {
        window.scrollTo(0, savedScrollY);

        savedScrollY = null;
      }
    });
  });

  observer.observe(widget, {
    childList: true,
    subtree: true
  });
});